import { render, staticRenderFns } from "./termsofuse.vue?vue&type=template&id=d8601392&scoped=true"
import script from "./termsofuse.vue?vue&type=script&lang=js"
export * from "./termsofuse.vue?vue&type=script&lang=js"
import style0 from "./termsofuse.vue?vue&type=style&index=0&id=d8601392&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8601392",
  null
  
)

export default component.exports